import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { publicApi } from "../utils/publicApi";
import "../styles/publicTheme.css";

const SiteFooter = () => {
  const { isAuthenticated, userAuthenticated, adminAuthenticated } = useAuth();
  const [pages, setPages] = useState([]);

  const dashPath = userAuthenticated
    ? "/dashboard"
    : adminAuthenticated
      ? "/admin/dashboard"
      : "/dashboard";

  useEffect(() => {
    (async () => {
      try {
        const res = await publicApi({ url: "admin/get-all-page" }).catch(() => null);
        if (res?.success) setPages(res.data || []);
      } catch {
        /* ignore */
      }
    })();
  }, []);

  return (
    <footer className="landing-footer">
      <div className="landing-footer-inner">
        <div>
          <strong>AlphaXCloud</strong>
          <p>
            WhatsApp API, campaigns, and inbox — one colorful workspace for teams that send
            every day.
          </p>
        </div>
        <div className="landing-footer-links">
          <Link to="/#how">How it works</Link>
          <Link to="/#features">Features</Link>
          <Link to="/faqs">FAQs</Link>
          <Link to="/testimonials">Testimonials</Link>
          {pages.map((p) => (
            <Link key={p.id} to={`/p/${p.slug}`}>
              {p.title}
            </Link>
          ))}
          {isAuthenticated ? (
            <Link to={dashPath}>Dashboard</Link>
          ) : (
            <Link to="/login">Login</Link>
          )}
        </div>
      </div>
      <p className="landing-copy">© {new Date().getFullYear()} AlphaXCloud</p>
    </footer>
  );
};

export default SiteFooter;
